query (
  $filter: SportTemplateFilter,
){
  sportTemplates: allSportTemplates(
    filter: $filter
    orderBy: NAME_ASC,
  ) {
    nodes {
      sportTemplateId
      name
      default
      sport {
        sportId
        sportName
      }
      marketTemplates: sportTemplateMarketsCountsBySportTemplateId {
        nodes {
          count: marketsCount
          enabledMarketsCount
        }
      }
      competitionTemplates: sportTemplateCompetitionsCountsBySportTemplateId {
        nodes {
          count: competitionsCount
        }
      }
    }
  }
}
